'use client';

import { useCallback, useEffect, useState } from 'react';
import {
  fetchRecordingStatus,
  isConfirmedFileRecording,
} from '@/lib/recording-status-client';

/**
 * Gravação room-composite (egress/S3) — não altera o flag useIsRecording() do LiveKit.
 */
export function useFileRecordingActive(roomName: string | undefined): boolean {
  const [active, setActive] = useState(false);

  const sync = useCallback(async () => {
    if (!roomName) {
      setActive(false);
      return;
    }
    try {
      const status = await fetchRecordingStatus(roomName);
      setActive(isConfirmedFileRecording(status));
    } catch {
      /* ignore transient errors */
    }
  }, [roomName]);

  useEffect(() => {
    void sync();

    const onStart = () => setActive(true);
    const onAwaiting = () => setActive(false);
    const onStop = () => setActive(false);

    window.addEventListener('recording:start', onStart);
    window.addEventListener('recording:preparing', onAwaiting);
    window.addEventListener('recording:starting', onAwaiting);
    window.addEventListener('recording:stop', onStop);

    // Backup lento: estado idle vem dos eventos window; 5s × N mounts martelava /api/record/status.
    const interval = setInterval(() => {
      void sync();
    }, 30_000);

    return () => {
      clearInterval(interval);
      window.removeEventListener('recording:start', onStart);
      window.removeEventListener('recording:preparing', onAwaiting);
      window.removeEventListener('recording:starting', onAwaiting);
      window.removeEventListener('recording:stop', onStop);
    };
  }, [roomName, sync]);

  return active;
}
